//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const ImplementationConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/payroll/payrollimpl",
      component: FuseLoadable({
        loader: () => import("./PayrollImpl.js")
      })
    }
  ]
  //end routes
};
